export default __webpack_public_path__ + "static/client-testimonial-founder-talpool-bob-gamon-12b3ce940b701259f690c2193bcb34c0.mp4";